import { __assign } from "tslib";
import React from 'react';
import LiteratureMonoHtmlView from './LiteratureHtml';
import LiteratureMonoReactView from './Literature';
var LiterartureMonoView = function (props) {
    if (props.isHtml) {
        return React.createElement(LiteratureMonoHtmlView, __assign({}, props));
    }
    return React.createElement(LiteratureMonoReactView, __assign({}, props));
};
LiterartureMonoView.displayName = 'LiterartureMonoView';
export default LiterartureMonoView;
//# sourceMappingURL=index.js.map